import { useEffect, useState } from 'react';
import { usePhrase, useRouter } from '@/hooks';
import { INMSurveysData } from '@/types';
import { Box, Button, Grid, Paper, Stack, Typography } from '@mui/material';
import { NM_DASHBOARD_PHRASES } from '@/consts/phrases/nmDashboardPhrases';
import { NMSurveyCard } from '../NMSurveyCard/NMSurveyCard';
import Link from '@/components/general/Link/Link';

interface NMDashboardProps {
    surveysData?: INMSurveysData;
}

export const NMDashboard = ({ surveysData }: NMDashboardProps) => {
    const { t } = usePhrase();
    const router = useRouter();
    const hasNoSurveys = !surveysData || !surveysData?.surveys?.length;
    const [isRedirected, setIsRedirected] = useState(false);

    useEffect(() => {
        if (hasNoSurveys && !isRedirected) {
            router.push('/?hhid=36238');
            setIsRedirected(true);
        }
    }, [hasNoSurveys, isRedirected, router]);

    if (hasNoSurveys) return null;

    return (
        <>
            <Paper sx={{ p: 2, mb: 3 }} className="nmDashboardWelcomeBlock">
                <Typography className="nmDashboardWelcomeTitle" variant="h4" sx={{ mb: 2 }}>
                    {t(NM_DASHBOARD_PHRASES.WELCOME_TITLE)}
                </Typography>
                <Typography className="nmDashboardWelcomeText" variant="subtitle2">
                    {t(NM_DASHBOARD_PHRASES.WELCOME_TEXT)}
                </Typography>
            </Paper>

            <Box sx={{ my: 3 }} className="nmDashboardSurveysList">
                <Grid container spacing={2}>
                    {surveysData.surveys.map((survey) => (
                        <Grid size={{ xs: 12, sm: 6 }} key={survey.surveyDisplayedId}>
                            <NMSurveyCard surveyData={survey} />
                        </Grid>
                    ))}
                </Grid>
            </Box>

            <Paper sx={{ p: 2 }} className="nmDashboardRegisterBlock">
                <Stack
                    sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        justifyContent: 'space-between',
                        alignItems: { xs: 'flex-start', sm: 'center' },
                    }}
                >
                    <Typography
                        variant="h5"
                        className="nmDashboardJoinTitle"
                        sx={{ p: 0, mb: { xs: 2, sm: 0 } }}
                    >
                        {t(NM_DASHBOARD_PHRASES.JOIN_TEXT)}
                    </Typography>
                    <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
                        <Link href="/?hhid=36237" passHref>
                            <Button
                                className="nmDashboardJoinButton"
                                color="primary"
                                size="large"
                                variant="outlined"
                                sx={{ width: { xs: '100%', sm: 'auto', whiteSpace: 'nowrap' } }}
                            >
                                {t(NM_DASHBOARD_PHRASES.CREATE_ACCOUNT_BUTTON)}
                            </Button>
                        </Link>
                    </Box>
                </Stack>
            </Paper>
            <Box sx={{ mt: 3 }}>
                <Typography variant="subtitle2" className="nmDashboardNote">
                    {t(NM_DASHBOARD_PHRASES.NOTE_INFO)}
                </Typography>
            </Box>
        </>
    );
};
